export default __webpack_public_path__ + "static/media/previous-icon-red.97ff2b87.svg";